"use strict";

var Backbone = require('backbone');
var _ = require('underscore');

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var messages = {
  valueRequired: gettext("This field is required")
};

var Guest = Backbone.Model.extend({
  validate: function(attributes, options) {
    var errors = {};
    var self = this;

    ["first_name", "last_name", "life_stage"].forEach(function(attrName){
      var attr = self.get(attrName);
      var valid = _.isString(attr) && !_.isEmpty(attr);

      if(!valid){
        errors[attrName] = messages.valueRequired;
      }
    });

    if (!_.isEmpty(errors)) {
      return errors;
    }
  }
});

module.exports = Guest;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/models/guest.js
 **/